import { type Question } from '@/types'

export const findMatrixRowByQuestionIdAndRowOrder = (
  questions: Question[],
  questionId: number,
  rowOrder: number
) => {
  const matrixQuestion = questions?.find(
    (question) =>
      Number(question.id) === Number(questionId) &&
      question.question_type?.question_type === 'matrix'
  )

  const matrixRow =
    matrixQuestion?.question_rows?.find(
      (row) => Number(row.order) === Number(rowOrder)
    ) || null

  return matrixRow
}
